import { SvgIcon } from "@material-ui/core";
import React from "react";

const GeneralIcon = props => (
  <SvgIcon>
    <g id="Icon/GeneralIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox={props.viewBox}
      >
        <g
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.6"
          clipPath="url(#GeneralIcon)"
        >
          <path d="M19.375 8.175c0 .344-.2.825-.444 1.069l-9.694 9.95a.622.622 0 01-.88 0l-7.55-7.55a.622.622 0 010-.882l9.955-9.693c.244-.244.72-.444 1.063-.444h6.925c.344 0 .625.281.625.625v6.925z"/>
          <path d="M15 6.875a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75z"/>
        </g>
        <defs>
          <clipPath id="GeneralIcon">
            <path fill="#fff" d="M0 0H20V20H0z"/>
          </clipPath>
        </defs>
      </svg>
    </g>
  </SvgIcon>
);

export default GeneralIcon;



// WEBPACK FOOTER //
// ./src/icons/GeneralIcon.jsx